import {Component, Input, OnInit} from '@angular/core';
import { EsimService } from '../../services/esim.service';
import { SimChoiceInterface } from '../../models/sim-choice.interface';
import { select, Store } from '@ngrx/store';
import { UpdateSimChoice } from '../../store/actions/sim-choice.actions';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { SimChoiceInterfaceState } from '../../store/state/sim-choice.state';
import { DimeloService } from '../../services/dimelo.service';
import { environment } from '../../../../../environments/environment';
import { PriceDetailsInterface } from '../../models/price-details.interface';

@Component({
  selector: 'app-sim-choice',
  templateUrl: './sim-choice.component.html',
  styleUrls: ['./sim-choice.component.css'],
  standalone: false
})
export class SimChoiceComponent implements OnInit {

  @Input()
  priceDetails?: PriceDetailsInterface;

  @Input()
  simChoiceInterface: SimChoiceInterface;

  @Input()
  procedureCode: string;

  @Input()
  procedureStatus?: string;

  @Input()
  disableEsim?: boolean;

  phones: Array<string>;
  consts = ConstsHelper;
  brand?: string;

  constructor(
      private esimService: EsimService,
      private dimeloService: DimeloService,
      private store: Store<any>
  ) {}

  ngOnInit() {
    this.store.pipe(select(ConstsHelper.REDUCER_SIM_CHOICE)).subscribe((response: SimChoiceInterfaceState) => {
      if (null !== response.simChoice) {
        this.simChoiceInterface = response.simChoice;
      }
    });
    this.brand = environment.data.brand;
    this.phones = [];
    this.esimService.getESimPhones().subscribe(result => {
      this.phones = result;
    });
  }

  updateSimChoice(simChoice: number) {
    this.simChoiceInterface.simChoice = simChoice;
    this.simChoiceInterface.displayErrorMessage = false;
    this.simChoiceInterface.esimPhone = null;
    this.store.dispatch(new UpdateSimChoice(this.simChoiceInterface));
  }

  assistance() {
    this.dimeloService.get().subscribe( response => {
      window.open(environment.data.assistanceUrl, '_blank');
    });
  }
}
